import { Event } from '@/event-bus/event';

export class MassEditLoseContentFocusEvent extends Event<void> {}
